<template>
  <div>
    <div class="invoices">
      <div class="w3-container">
        <div class="headerGrid">
          <div>
            <header>
              <h2>Add Invoice</h2>
            </header>
          </div>
          <div>
            <router-link to="/invoices" class="w3-button w3-red w3-small w3-right vmiddle">
              <i class="fas fa-times" style="margin-right:8px;"></i>Cancel
            </router-link>
            <button @click="saveInvoice()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
              <i class="fas fa-save" style="margin-right:8px;"></i>Save
            </button>
          </div>
        </div>

        <div class="details">
          <div>
            <div class="outline w3-white">
              <header class="light outline">
                <h5>Invoice Details</h5>
              </header>
              <div class="w3-padding">
                <div class="detailsGrid">
                  <span>Status:</span>
                  <select dir="rtl" class="w3-select w3-padding" style="appearance:none;" name="status" v-model="newInvoice.status">
                    <option value="unpaid">Unpaid</option>
                    <option value="draft">Draft</option>
                    <option value="paid">Paid</option>
                  </select>
                </div>
                <div class="detailsGrid">
                  <span>Issued:</span>
                  <input class="w3-input w3-right-align" type="date" :value="newInvoice.issue_date | inputDate" />
                </div>
                <div class="detailsGrid">
                  <span>Due:</span>
                  <input class="w3-input w3-right-align" type="date" :value="newInvoice.due_date | inputDate" />
                </div>
                <div class="detailsGrid">
                  <span>Total:</span>
                  <span class="w3-padding w3-right-align">{{newInvoice.total | currency}}</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="outline w3-white">
              <header class="light outline">
                <h5>Pay To</h5>
              </header>
              <div class="w3-padding">
                <div class="w3-bar-block">
                  <div class="w3-bar-item">
                    Mobile Seven<br/>
                    61 Magnolia Ave.<br/>
                    Ormond Beach, FL 32174<br/>
                    386-451-2795<br/>
                    info@gomobile7.com
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="outline w3-white">
              <header class="light outline">
                <h5>Bill To</h5>
              </header>
              <v-select v-model="newInvoice.client" label="name" :options="state.admin.global.clients.list">
                <template slot="option" slot-scope="option">
                  <div class="w3-container">
                    <p>
                      {{ option.name }}<br/>
                      {{ option.email }}<br/>
                      {{ option.company }}
                    </p>
                  </div>
                </template>
              </v-select>
              <!-- <button @click="logClient()">Test</button> -->
              <div>
                <div class="w3-bar-block">
                  <div class="w3-bar-item" v-if="newInvoice.client.name">
                    {{newInvoice.client.company}}<br/>
                    {{newInvoice.client.name}}<br/>
                    {{newInvoice.client.email}}<br/>
                    {{newInvoice.client.address1}}<br/>
                    <span v-if="newInvoice.client.address2 !== ''">{{newInvoice.client.address2}}<br/></span>
                    <span>{{newInvoice.client.city}}, </span><span>{{newInvoice.client.state}}&nbsp;&nbsp;</span><span>{{newInvoice.client.zipcode}}</span>
                    <!-- <span v-if="newInvoice.client.phone !== ''"><br/>{{newInvoice.client.phone}}</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w3-row w3-margin-bottom">
          <div class="outline w3-white">
            <header class="light outline">
              <h5>Services</h5>
            </header>
            <div class="servicesTableGrid" v-for="(item, key, i) in newInvoice.items" :key="i">
              <div style="padding:8px 0 8px 16px;">
                {{item.text}}
              </div>
              <div class="w3-right-align">
                <div class="vmiddle">
                  {{item.amount | currency}}
                </div>
              </div>
              <div class="w3-right-align">
                <div class="vmiddle">
                  <button class="w3-button w3-red w3-small" style="padding:6px 16px;" @click="removeItem(key)">REMOVE</button>
                </div>
              </div>
            </div>

            <div class="servicesAddGrid">
              <div>
                <input class="w3-input" style="border:none;" name="item" type="text" placeholder="add item" v-model="lineItem.text" :class="{'w3-border-red':textError}" @keyup="textError = false">
              </div>
              <div>
                <money class="w3-input w3-right-align" style="border:none;" v-model="lineItem.amount" v-bind="money" :class="{'w3-border-red':amountError}" @keyup="amountError = false" @keydown.enter="addItem()"></money>
              </div>
              <div>
                <button class="w3-button w3-small w3-green vmiddle" style="padding:6px 16px;" @click="addItem()">ADD</button>
              </div>
            </div>
          </div>
        </div>

        <div class="w3-row w3-margin-bottom">
          <div class="outline w3-white">
            <header class="light outline">
              <h5>Notes</h5>
            </header>
            <div>
              <textarea class="w3-input" rows="3"></textarea>
            </div>
          </div>
        </div>

        <div class="w3-row">
          <router-link to="/invoices" class="w3-button w3-red w3-small w3-right">
            <i class="fas fa-times" style="margin-right:8px;"></i>Cancel
          </router-link>
          <button @click="saveInvoice()" class="w3-button w3-green w3-small w3-right" style="margin-right:8px;">
            <i class="fas fa-save" style="margin-right:8px;"></i>Save
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore'
import {Money} from 'v-money'

export default {
  name: 'addInvoice',
  components: {Money},
  props: {
    selectedClient: Object
  },
  data() {
    return {
      state: dataStore.state,
      newInvoice: {
        client: {
          name: null
        },
        status: 'unpaid',
        total: 0,
        items: [],
        issue_date: new Date(),
        due_date: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString()
      },
      lineItem: {
        text: '',
        amount: 0
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      },
      amountError: false,
      textError: false
    }
  },
  created() {
    dataStore.getAdminGlobalData()
    if (this.selectedClient && this.selectedClient.email) {
      this.newInvoice.client = this.selectedClient
    }
  },
  methods: {
    logClient() {
      console.log(this.newInvoice.client)
    },
    addItem() {
      this.textError = false
      this.amountError = false
      if (this.lineItem.text === '') {
        this.textError = true
      }
      if (this.lineItem.amount === 0) {
        this.amountError = true
      }
      if (this.lineItem.text === '' || this.lineItem.amount === 0) {
        return
      }
      this.newInvoice.items.push({
        text: this.lineItem.text,
        amount: this.lineItem.amount
      })
      this.newInvoice.total += this.lineItem.amount
      this.lineItem.text = ''
      this.lineItem.amount = 0
    },
    removeItem(key) {
      this.newInvoice.total -= this.newInvoice.items[key].amount
      this.newInvoice.items.splice(key, 1)
    },
    saveInvoice() {
      dataStore.saveInvoice(this.newInvoice).then((res) => {
        this.$router.replace('/invoices')
      })
    }
  }
}
</script>

<style scoped>
.w3-select {background:#fafafa; border:1px solid #ccc; border-radius:5px;}
.details {margin-bottom:8px; display:grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); grid-gap:8px;}

.lineText {width:85%; vertical-align:middle;}
.lineAmount {width:10%; vertical-align:middle;}
.lineAdd {vertical-align:middle;}

.detailsGrid {display:grid; grid-template-columns: 3fr 7fr; grid-gap:8px; align-items: center;}
.servicesTableGrid {display:grid; grid-template-columns: 10fr 1fr 1fr; grid-gap:8px; border-bottom:1px solid #eee;}
.servicesAddGrid {display:grid; grid-template-columns: 8fr 1fr auto;}
.servicesTableGrid:last-child {border-bottom:0;}

@media screen and (max-width:800px) {
  .servicesTableGrid {grid-template-columns: 2.5fr 1fr auto;}
  .servicesAddGrid {grid-template-columns: 2.5fr 1fr auto;}
}

@media screen and (max-width:600px) {

}

</style>



// WEBPACK FOOTER //
// src/components/addInvoice.vue